import React from 'react'

const Home = () => {
	return (
		<div>
			Home component works!
		</div>
	)
}

export default Home
